/**
 * Toggle smallscreen nav on click
 *
 * @param {string} toggle - selector for toggle button
 * @param {string} wrapper - selector for nav wrapper
 */

import $ from 'jquery';

export const navToggle = (
    toggle = '#ghwp-main-toggle',
    wrapper = '#ghwp-navbar'
) => {
    $(wrapper).attr('aria-hidden', 'true');

    $(toggle).click(function() {
        const $el = $(this);
        const $menu = $(wrapper);
        const hasStage = $('body').hasClass('ghwp-layout-stage');

        let expanded = $el.attr('aria-expanded') === 'true';

        if (hasStage) {
            const wasScrolled = $(window).scrollTop() > 16;

            if (!wasScrolled) {
                if (!expanded) {
                    $('body').addClass('ghwp-was-scrolled');
                } else {
                    $('body').removeClass('ghwp-was-scrolled');
                }
            }
        }

        $el.attr('aria-expanded', !expanded);
        $menu.attr('aria-hidden', expanded);
    });
};
